<template>
  <div class="container mx-auto p-4">
    <CRow>
      <CCol xs="12" sm="12" md="12" lg="4" xl="4">
        <CCard>
          <CCardHeader class="d-flex justify-content-between">
            <span><i class="fas fa-store"></i>&nbsp;Stock</span>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="12">
                <CSelect label="Sedes" :options="data_campus" placeholder="--Seleccione una sede --"
                  :value.sync="selectedCampus" @change="onCampusChange" :disabled="cpDisabledCampu" />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="8" xl="8">
        <CTableWrapper :items="filteredProducts" :fields="fields" hover :striped="true" :border="true" small fixed
          caption="Lista de Productos" icon="fas fa-box" @mtdBack="returnHome" v-if="$store.getters.get_rol.id == 4" />
        <CTableWrapper :items="filteredProductsVen" :fields="fieldsVen" hover :striped="true" :border="true" small fixed
          caption="Lista de Productos" icon="fas fa-box" @mtdBack="returnHome" v-else />
      </CCol>
    </CRow>
  </div>
</template>
<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "type", label: "Tipo", _style: "width:10%;" },
  { key: "campu", label: "Sede", _style: "width:15%;" },
  { key: "label", label: "Nombre", _style: "width:20%;" },
  { key: "stock", label: "Stock", _style: "width:15%;" },
  { key: "stock_min", label: "Stock Min", _style: "width:15%;" },
  { key: "label_unit", label: "Unidad", _style: "width:15%;" },
  { key: "cost", label: "Prec. Compra", _style: "width:15%;" },
  { key: "price", label: "Prec. Venta", _style: "width:15%;" },
  { key: "status", label: "Estado", _style: "width:15%;" },
];
const fieldsVen = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "type", label: "Tipo", _style: "width:10%;" },
  { key: "campu", label: "Sede", _style: "width:15%;" },
  { key: "label", label: "Nombre", _style: "width:20%;" },
  { key: "stock", label: "Stock", _style: "width:15%;" },
  { key: "stock_min", label: "Stock Min", _style: "width:15%;" },
  { key: "label_unit", label: "Unidad", _style: "width:15%;" },
  { key: "price", label: "Prec. Venta", _style: "width:15%;" },
  { key: "status", label: "Estado", _style: "width:15%;" },
];
import { mapActions } from "vuex";
import CTableWrapper from "@/components/shared/datatable/Table.vue";
export default {
  name: "stock",
  components: { CTableWrapper },
  data() {
    return {
      fields,
      fieldsVen,
      rol_id: this.$store.getters.get_rol.id,
      data_campus: [],
      data_product: [],
      data_product_ven: [],
      searchQuery: "", // Para la búsqueda
      selectedCampus: null,
    };
  },
  computed: {
    filteredProducts() {
      return this.data_product.filter((item) => {
        const search = this.searchQuery.toLowerCase();
        return (
          item.label.toLowerCase().includes(search) ||
          item.label_unit.toLowerCase().includes(search) ||
          item.price.toString().includes(search)
        );
      });
    },
    filteredProductsVen() {
      return this.data_product_ven.filter((item) => {
        const search = this.searchQuery.toLowerCase();
        return (
          item.label.toLowerCase().includes(search) ||
          item.label_unit.toLowerCase().includes(search) ||
          item.price.toString().includes(search)
        );
      });
    },
    cpDisabledCampu() {
      if (this.rol_id == 4 || this.rol_id == 8) {
        return false;
      } else {
        return true;
      }
    }
  },
  watch: {},
  created() {
    // this.showProduct();
    this.getCampus();
    this.setDefaultCampus();
    // this.onCampusChange();
  },
  methods: {
    ...mapActions(["get", "post"]),
    returnHome() {
      this.$emit("returnHome");
    },
    getCampus() {
      // Usar el endpoint de stock que ahora devuelve también los campus
      let url = this.$store.getters.get__url + "/stock/byProduct/" + this.$store.getters.get_company.id;
      this.get({
        url: url,
        token: this.$store.getters.get__token,
      }).then((response) => {
        if (response.statusCode == 200 && response.data.campus) {
          this.data_campus = [
            { label: "Todos", value: null },
            ...response.data.campus.map((element) => ({
              label: element.name,
              value: element.id,
            })),
          ];
        }
      }).catch(() => {
        // Fallback al endpoint original si hay algún problema
        this.get({
          url:
            this.$store.getters.get__url +
            "/stock_transfer/getCampus/" +
            this.$store.getters.get_company.id,
          token: this.$store.getters.get__token,
        }).then((response) => {
          if (response.statusCode == 200) {
            this.data_campus = [
              { label: "Todos", value: null },
              ...response.data.map((element) => ({
                label: element.name,
                value: element.id,
              })),
            ];
          }
        });
      });
    },
    setDefaultCampus() {
      if (this.rol_id === 4) {
        this.selectedCampus = null; // "Todos"
        this.onCampusChange();
      } else {
        this.selectedCampus = this.$store.getters.get_campu.id;
        this.onCampusChange();
      }
    },
    onCampusChange() {
      if (this.selectedCampus === null) {
        this.showProduct();
      } else {
        this.showProduct(this.selectedCampus);
      }
    },
    showProduct(campuId = null) {
      let url = this.$store.getters.get__url + "/stock/byProduct/" + this.$store.getters.get_company.id;
      if (campuId !== null) {
        url += "/" + campuId;
      }
      this.get({
        url: url,
        token: this.$store.getters.get__token,
      }).then((response) => {
        this.data_product = [];
        this.data_product_ven = [];
        let index = 1;
        response.data.data.forEach((arr) => {
          if (arr.type === 'producto') {
            // Manejar productos
            const { stock, product_unit, almacen } = arr;
            const stock_min = product_unit.product.stock_min ? product_unit.product.stock_min : 0;
            const itemData = {
              label: product_unit.product.name,
              value: product_unit.product.id,
              price: product_unit.product.price[0] ? product_unit.product.price[0].sale_price : 0,
              cost: product_unit.product.price[0] ? product_unit.product.price[0].purchase_price : 0,
              value_unit: product_unit.unit.id,
              label_unit: product_unit.unit.name,
              stock: parseInt(stock),
              stock_min: stock_min,
              index: index++,
              type: 'Producto',
              campu: almacen ? almacen.campu.name : 'N/A',
              status: this.getStockStatus(stock, stock_min),
            };
            
            if (this.$store.getters.get_rol.id == 4) {
              this.data_product.push(itemData);
            } else {
              this.data_product_ven.push(itemData);
            }
          } else if (arr.type === 'insumo') {
            // Manejar insumos
            const { stock, insumo, almacen } = arr;
            const stock_min = insumo.stock_minimo || 0;
            const itemData = {
              label: insumo.name,
              value: insumo.id,
              price: 0, // Los insumos no tienen precio de venta
              cost: insumo.price_cost || 0,
              value_unit: insumo.unit.id,
              label_unit: insumo.unit.name,
              stock: parseInt(stock),
              stock_min: stock_min,
              index: index++,
              type: 'Insumo',
              campu: almacen ? almacen.campu.name : 'N/A',
              status: this.getStockStatus(stock, stock_min),
            };
            
            if (this.$store.getters.get_rol.id == 4) {
              this.data_product.push(itemData);
            } else {
              this.data_product_ven.push(itemData);
            }
          }
        });
      });
    },
    getStockStatus(stock, stock_min) {
      if (stock == 0) {
        return "Agotado";
      } else if (stock <= stock_min) {
        return "Existencias bajas";
      } else if (stock < 0) {
        return "Por reponer";
      } else {
        return "Stock disponible";
      }
    },
  },
};
</script>
<style scoped>
.equal-height-header {
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (min-width: 300px) {

  /* sm */
  .equal-height-header {
    min-height: 20px;
  }
}

@media (min-width: 576px) {

  /* sm */
  .equal-height-header {
    min-height: 20px;
  }
}

@media (min-width: 768px) {

  /* md */
  .equal-height-header {
    min-height: 80px;
  }
}
</style>
